__webpack_require__.p = "/getting-started-drawer-container/account-setup/";